/**
 * Created by lihanying on 2017/10/19.
 */
import React from 'react'
import { Modal, Row, Col, Input, Message } from 'antd'

export default class extends React.Component {
  state = {
    table_price: '',
    low_minute: 0,
  }

  isValid = () => {
    const { table_price, low_minute } = this.state
    const { tables } = this.props
    let flag = true
    let hasOfficialTable = false
    tables.map((item, index) => {
      if (item.total_c != '1') {
        hasOfficialTable = true
      }
    })
    if (hasOfficialTable && table_price <= 0 && table_price != '') {
      Message.error('非休闲区价格设置不能低于0元')
      flag = false
    }
    if (low_minute > 0 && low_minute <= 10) {
      Message.error('桌台最低消费不低于10分钟')
      flag = false
    }
    return flag
  }

  render() {
    const { modalLowCsp, tables } = this.props
    return (
      <div>
        <Modal
          title="低消设置"
          visible={modalLowCsp}
          onOk={() => {
            if (!this.isValid()) {
              return
            }
            this.props.handleOk({
              price: this.state.table_price,
              low_minute: this.state.low_minute,
            })
          }}
          onCancel={this.props.handleCancel}
          width="800px"
        >
          <div className="gutter-example">
            <Row gutter={16}>
              {tables.map((item, idx) => {
                return (
                  <Col className="gutter-row" span={4} key={idx}>
                    <div className="gutter-box">{`${idx + 1}.${
                      item.name
                    }`}</div>
                  </Col>
                )
              })}
            </Row>
          </div>
          <div style={{ marginTop: '1rem' }}>
            <span>基本价格[元/小时]:</span>
            <Input
              size="large"
              style={{ width: '50%', marginLeft: '1rem' }}
              placeholder="桌台的价格,可以不填"
              onChange={(e) => this.setState({ table_price: e.target.value })}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            <span>最低消费[分钟]:</span>
            <Input
              size="large"
              style={{ width: '50%', marginLeft: '2rem' }}
              placeholder="0或不填表示无抵消"
              onChange={(e) => this.setState({ low_minute: e.target.value })}
            />
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/lowCsp.js